import { getCommissionCycles } from "@/Common/api/commissionCycles/queries";
import { useLocationId } from "@/Common/hooks/Location/useLocationId";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch commission cycles for the current location (including all statuses).
 */
export function useLocationCycles() {
	const locationId = useLocationId();

	const { data, isLoading } = useQuery({
		queryKey: ["locationCycles", locationId],
		queryFn: () => getCommissionCycles(locationId, { excludeStatuses: [] }),
		staleTime: Infinity,
		enabled: Boolean(locationId),
	});

	return { data, isLoading };
}
